import type { ColDef, ColGroupDef } from 'ag-grid-community';
import type { ColumnDynamics } from '../columns/types';
import type { ColumnOrColumnGroup } from '../types';

/** A ColumnDynamicsSpec defines the behavior of a column's dynamic properties */
export interface ColumnDynamicsSpec<ParamsType = any, TData = any, StateType = any> {
  /** The label for the column spec to show in the blotter's menu items */
  label: string;
  /** The key for the spec */
  type: string;
  /** Column builder for the spec */
  getColumn(dynamics: ColumnDynamics<StateType>): ColumnOrColumnGroup<ParamsType, TData, StateType>;
  /** Get initial / default settings, used when new columns are added for example */
  getInitialSettings(): StateType;
  /** If true, openSettings() will be called immediately when a column is added to the grid */
  openSettingsOnCreation?: boolean;
  /** Called when the user clicks on Edit Column. Is called with the current settings state, and a save function to be called when you want to apply new settings */
  openSettings?(currentSettings: StateType | undefined, save: (newSettings: StateType | undefined) => void): void;
  /** Optional ColDef overlay applied generically to columns using this dynamics spec. */
  getColDefOverlay?(dynamics: ColumnDynamics<StateType>): Partial<ColDef<TData> | ColGroupDef<TData>>;
}

/** Use when reading the effective settings from a column's dynamics/state descriptors. */
export function getColumnDynamicsState<StateType>(dynamics: { state?: StateType; initialState: StateType }): StateType;
export function getColumnDynamicsState<StateType>(
  dynamics: { state?: StateType; initialState?: StateType } | undefined
): StateType | undefined;
export function getColumnDynamicsState<StateType>(
  dynamics: { state?: StateType; initialState?: StateType } | undefined
): StateType | undefined {
  return dynamics?.state ?? dynamics?.initialState;
}
